import Client from './client';

export default class OrderCancellations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/order/cancellations`, options);
  }

  putOrganizationAndOrderByOrganizationIdAndNumber(organizationId, number, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/order/cancellations/organization/${organizationId}/order/${number}`, {
      ...options,
       method: 'PUT',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/order/cancellations/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/order/cancellations/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
